module.exports = __webpack_public_path__ + "static/media/navbar-extra-shape-onogate.02dd10cf.png";